<template>
  <div>
    <populate-form
      formTitle="預約紀錄操作"
      fkey="ro01"
      ref="operateForm"
      populateOptionVar="operateOptions"
      formDataObjVar="operateData"
    ></populate-form>
  </div>
</template>

<script>

/*
  popup顯示預約劃位紀錄的子組件
  會包含：線上互動劃位,線上直接確認劃位與外部自訂劃位三種
  不同類型顯示的不同
  另外可以店家可做的操作也不同
  
  外部劃位店家可以自行編輯與取消
  
  互動與被用戶直接確認的劃位則只能操作通知用戶取消
  =>到隔天凌晨前可以後悔撤回取消通知,否則取消自動生效且留下預約放鳥不良紀錄
  =>店家主動聯繫追蹤用戶,請用戶理解取消原因並線上確認則可以不留下預約放鳥不良紀錄
  =>晚點還有訊息留言互動操作,可以對此用戶留下店家文字訊息留言(如提醒到店前準備等等)

*/
export default {
  name: 'ReserveOperateView',
  props: {
    'minuteInterval':Number,
    'op_hours':Array,
    'cancel_create':Function,
    'successReload':Function,
  },
  data: function () {
    return {
      operateData:{},
      operateOptions:[
        {
          componentType:'span',
          col:2,
          placeholder:'預約類型:'
        },
        {
          componentType:'span',
          col:2,
          akey:'reserve_type_name',
          placeholder:''
        },
        {
          componentType:'span',
          col:2,
          placeholder:'對象:'
        },
        {
          componentType:'span',
          col:6,
          akey:'reserve_user',
          placeholder:'對象'
        },
        {
          componentType:'span',
          col:2,
          placeholder:'何時確認:'
        },
        {
          componentType:'span',
          akey:'reserve_time',
          col:4,
          placeholder:''
        },
        {
          componentType:'span',
          col:6,
          placeholder:''
        },
        {
          componentType:'span',
          col:2,
          placeholder:'開始時間:',
          //不能直接用prop的子屬性render,時間差的問題,會整個死掉啊
          //hide:this.reserve_item.data.reserve_type==='external_reserve'
          dynamicHide:this.is_external_non_editable
        },
        {
          componentType:'span',
          akey:'reserve_start_time',
          col:4,
          placeholder:'',
          //hide:this.reserve_item.data.reserve_type==='external_reserve'
          dynamicHide:this.is_external_non_editable
        },
        {
          componentType:'span',
          col:2,
          placeholder:'結束時間:',
          //hide:this.reserve_item.data.reserve_type==='external_reserve'
          dynamicHide:this.is_external_non_editable
        },
        {
          componentType:'span',
          akey:'reserve_end_time',
          col:4,
          placeholder:'',
          //hide:this.reserve_item.data.reserve_type==='external_reserve'
          dynamicHide:this.is_external_non_editable
        },
        {
          componentType:'date-picker',
          col:4,
          akey:'reserve_date',
          placeholder:'劃位日期',
          //hide:this.reserve_item.data.reserve_type!=='external_reserve'
          disabled:true,
          dynamicHide:this.is_not_external_non_editable
        },
        {
          componentType:'vue-timepicker',
          col:4,
          akey:'reserve_starttime',
          placeholder:'開始時間',
          minHour:8,
          maxHour:23,
          defaultValue:"",
          minuteInterval:this.minuteInterval,
          //hide:this.reserve_item.data.reserve_type!=='external_reserve'
          dynamicHide:this.is_not_external_non_editable
        },
        {
          componentType:'vue-timepicker',
          col:4,
          akey:'reserve_endtime',
          placeholder:'結束時間',
          minHour:8,
          maxHour:23,
          defaultValue:"",
          minuteInterval:this.minuteInterval,
          //hide:this.reserve_item.data.reserve_type!=='external_reserve'
          dynamicHide:this.is_not_external_non_editable
        },
        {
          componentType:'span',
          col:2,
          placeholder:'店家帳號:'
        },
        {
          componentType:'span',
          akey:'store_operate_account_name',
          col:4,
          placeholder:''
        },
        {
          componentType:'span',
          col:2,
          placeholder:'直接確認:'
        },
        {
          componentType:'b-form-select',
          akey:'is_direct_reserve',
          col:4,
          dataOptions:[{text:'是',value:1},{text:'否',value:0}],
          disabled:true,
          placeholder:''
        },
        {
          componentType:'span',
          col:2,
          placeholder:'備註:'
        },
        {
          componentType:'text',
          akey:'reserve_remark',
          col:10,
          placeholder:'輸入備註',
          dynamicDisabled:this.is_non_editable
        },
        {
          componentType:'b-button',
          col:3,
          placeholder:'更新備註',
          execCallback:this.updateRemark,
          dynamicHide:this.is_non_editable
        },
        {
          componentType:'b-button',
          col:3,
          placeholder:'修改外部劃位',
          //hide:this.reserve_item.data.reserve_type!=='external_reserve'
          dynamicHide:this.is_not_external_non_editable,
          execCallback:this.updateReserve
        },
        {
          componentType:'b-button',
          col:3,
          placeholder:'移除外部劃位',
          //hide:this.reserve_item.data.reserve_type!=='external_reserve'
          dynamicHide:this.is_not_external_non_editable,
          execCallback:this.cancelExtReserve
        },
        {
          componentType:'b-button',
          col:3,
          placeholder:'提議取消',
          //hide:this.reserve_item.data.reserve_type==='external_reserve'
          dynamicHide:this.is_external_non_editable,
          execCallback:this.cancelConfirmedReservation
        },
      ],
    }
  },
  methods: {
    cancelConfirmedReservation() {
      if (!this.operateData.reserve_remark) {
        this.$refs.operateForm.triggerAlert("請填寫取消留言")
        return
      }
      this.$bus.fnShowConfirm("確認向用戶提出取消劃位嗎？", () => {
        let Param = {
          'module':'store',
          'method':'notifyReservationCancelByStore',
          'reservation_result_id': this.operateData.reservation_result_id,
          'remark':this.operateData.reserve_remark
        }
        this.$bus.apiCall(Param, function (data, vm) {
          if (data.ok === 0) {
            vm.$refs.operateForm.triggerAlert(data.msg)
            vm.$bus.fnClosePopup()
            return
          }
          vm.$bus.fnClosePopup()
          //直接當dataOptions用
          vm.successReload()
        }, this)
      })
    },
    cancelExtReserve() {
      this.$bus.fnShowConfirm("確認刪除嗎？", () => {
        let Param = {
          'module':'store',
          'method':'cancelCustomReserve',
          'reservation_id': this.operateData.reservation_result_id,
          'remark':this.operateData.reserve_remark
        }
        this.$bus.apiCall(Param, function (data, vm) {
          if (data.ok === 0) {
            vm.$refs.operateForm.triggerAlert(data.msg)
            vm.$bus.fnClosePopup()
            return
          }
          vm.$bus.fnClosePopup()
          //直接當dataOptions用
          vm.successReload()
        }, this)
      })
    },
    updateRemark(evt) {
      this.updateReserve(evt, true)
    },
    updateReserve(evt, remark_only = false) {
      let start_time = this.operateData.reserve_type === 'external_reserve'?(this.operateData.reserve_date+' '+this.operateData.reserve_starttime):''
      let end_time = this.operateData.reserve_type === 'external_reserve'?(this.operateData.reserve_date+' '+this.operateData.reserve_endtime):''
      start_time = start_time+(start_time.length===19?'':':00')
      end_time = end_time+(end_time.length===19?'':':00')
      // 只更新備註不要傳起訖時間
      if (remark_only) {
        start_time = ''
        end_time = ''
      }
      else if (start_time >= end_time) {
        // 這裡沒做自動帶結束時間,要檢查開始時間不能比結束時間晚(目前沒做跨日預約)
        this.$refs.operateForm.triggerAlert("開始時間必須早於結束時間,目前不允許跨日的預約時段")
        return
      }
      let Param = {
        'module':'store',
        'method':'updateCustomReserve',
        'reservation_id': this.operateData.reservation_result_id,
        'remark':this.operateData.reserve_remark,
        'start_time':start_time,
        'end_time':end_time
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
          vm.$bus.fnShowInfo(data.msg)
          return
        }
        //直接當dataOptions用
        vm.successReload()
      }, this)
    },
    setData(reserve_item) {
      this.operateData = reserve_item.data
      // 要根據查看的預約類型動態隱藏與顯示一些欄位和按鈕
      // 因為是popup打開才知道點的是什麼,直接把hide屬性設定在operateOptions裡沒有用
      // operateOptions多配一個自用的屬性
      for (let i=0;i<this.operateOptions.length;i++) {
        if (this.operateOptions[i].dynamicHide !== undefined) {
          this.operateOptions[i].hide = this.operateOptions[i].dynamicHide()
        }
        if (this.operateOptions[i].dynamicDisabled !== undefined) {
          this.operateOptions[i].disabled = this.operateOptions[i].dynamicDisabled()
        }
        if (this.operateOptions[i].componentType === 'vue-timepicker') {
          this.operateOptions[i].minuteInterval = this.minuteInterval
          this.operateOptions[i].minHour = this.op_hours[0].hour
          this.operateOptions[i].maxHour = this.op_hours[this.op_hours.length-1].hour
        }
      }
      // 囧囧的把設定reserve_starttime等兩個timepicket的變數延後就能避開傳遞參數的警告= =
      setTimeout(() => {
        if (this.operateData.reserve_type === 'external_reserve') {
          this.operateData.reserve_date = this.getDateByStr(this.operateData.reserve_start_time)
          this.operateData.reserve_starttime = this.getPartFromDatetimeStr(this.operateData.reserve_start_time,'hourminute')
          this.operateData.reserve_endtime = this.getPartFromDatetimeStr(this.operateData.reserve_end_time,'hourminute')
        }
        this.$refs.operateForm.refreshModelVar()
      }, 100);
    },
    is_external_non_editable() {
      return (this.operateData.reserve_type === 'external_reserve' || new Date(this.operateData.reserve_start_time) < Date.now() )
    },
    is_not_external_non_editable() {
      return (this.operateData.reserve_type !== 'external_reserve' || new Date(this.operateData.reserve_start_time) < Date.now() )
    },
    is_non_editable() {
      return new Date(this.operateData.reserve_start_time) < Date.now()
    },
  },
  computed: {
    
  },
  created() {
    if (this.op_hours.length) {
      for (let i=0;i<this.operateOptions.length;i++) {
        if (this.operateOptions[i].componentType === 'vue-timepicker') {
          this.operateOptions[i].minHour = this.op_hours[0].hour
          this.operateOptions[i].maxHour = this.op_hours[this.op_hours.length-1].hour
        }
      }
    }
  },
  mounted () {
    //this.operateData = this.reserve_item
  },
  watch:{
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
